import { render, staticRenderFns } from "./OtrosProductos.vue?vue&type=template&id=8f82d7da&scoped=true&"
import script from "./OtrosProductos.vue?vue&type=script&lang=js&"
export * from "./OtrosProductos.vue?vue&type=script&lang=js&"
import style0 from "./OtrosProductos.vue?vue&type=style&index=0&id=8f82d7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f82d7da",
  null
  
)

export default component.exports